import { cn } from '../../lib/utils'

const sizeClasses = {
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-11 w-11 text-sm',
  xl: 'h-14 w-14 text-base',
}

export function Avatar({ name, color, src, size = 'md', className }) {
  const initials = name
    ? name
        .split(' ')
        .map((n) => n[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    : '?'

  if (src) {
    return (
      <img
        src={src}
        alt={name || ''}
        className={cn('rounded-full object-cover', sizeClasses[size], className)}
      />
    )
  }

  return (
    <div
      className={cn(
        'inline-flex items-center justify-center rounded-full font-bold text-white',
        sizeClasses[size],
        className,
      )}
      style={{ backgroundColor: color || '#6366f1' }}
      title={name}
    >
      {initials}
    </div>
  )
}

export function AvatarGroup({ avatars = [], max = 4, size = 'sm' }) {
  const visible = avatars.slice(0, max)
  const remaining = avatars.length - max

  return (
    <div className="flex -space-x-2">
      {visible.map((avatar, i) => (
        <Avatar
          key={avatar.id || i}
          name={avatar.name}
          color={avatar.color}
          src={avatar.src}
          size={size}
          className="ring-2 ring-card"
        />
      ))}
      {remaining > 0 && (
        <div
          className={cn(
            'inline-flex items-center justify-center rounded-full bg-muted font-bold text-muted-foreground ring-2 ring-card',
            sizeClasses[size],
          )}
        >
          +{remaining}
        </div>
      )}
    </div>
  )
}
